const apiBaseUrl = String(process.env.REACT_APP_BACKEND_API_URL || "").trim();

const withAuthHeaders = (token, headers = {}) => ({
  ...headers,
  ...(token ? { Authorization: `Bearer ${token}` } : {}),
});

const request = async (path, options = {}) => {
  const response = await fetch(`${apiBaseUrl}${path}`, options);

  if (!response.ok) {
    let message = "Request failed";
    try {
      const errorData = await response.json();
      message = errorData?.detail || errorData?.message || message;
    } catch {
      message = response.statusText || message;
    }
    throw new Error(message);
  }

  if (response.status === 204) {
    return null;
  }

  return response.json();
};

export const fetchAllBlogs = () => request("/blogs");

export const fetchBlogsByUser = (userId) => request(`/blogs/${userId}`);

export const fetchBlogById = async (blogId) => {
  try {
    return await request(`/blogs/${blogId}`);
  } catch (error) {
    return request(`/blog/${blogId}`);
  }
};

export const createBlog = (payload, token) =>
  request("/blogs", {
    method: "POST",
    headers: {
      ...withAuthHeaders(token, {
        "Content-Type": "application/json",
      }),
    },
    body: JSON.stringify(payload),
  });

export const deleteBlog = (blogId, token) =>
  request(`/blogs/${blogId}`, {
    method: "DELETE",
    headers: withAuthHeaders(token),
  });

export const likeBlog = (blogId, token) =>
  request(`/blogs/${blogId}/like`, {
    method: "POST",
    headers: withAuthHeaders(token),
  });

export const fetchComments = (blogId) => request(`/blogs/comment/${blogId}`);

export const postComment = (blogId, payload, token) =>
  request(`/blogs/${blogId}/comment`, {
    method: "POST",
    headers: {
      ...withAuthHeaders(token, {
        "Content-Type": "application/json",
      }),
    },
    body: JSON.stringify(payload),
  });
